<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="bell"
    title="Настроить уведомления"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body">
    <div *ngIf="!isLoaded; else contentBlock" class="mt-4 mb-3">
      <div class="loader-line"></div>
    </div>
    <ng-template #contentBlock>
      <div *ngIf="currentTimestamp > arSettings.mute_until * 1000 || arSettings.mute_until === 0; else timeBlock">
        <p>Выберите на какое время отключить уведолмения для этого чата:</p>
        <nz-slider
          [(ngModel)]="timeVal"
          (ngModelChange)="timeChange($event)"
          [nzMarks]="marks"
          nzDots
          [ngModel]="37"
        ></nz-slider>
      </div>

      <ng-template #timeBlock>
        <p *ngIf="arSettings.mute_until > 0">
          Уведолмения отключены до
          {{ arSettings.mute_until * 1000 | date: 'MMM d, y, h:mm' }}
        </p>
        <div class="text-center">
          <button (click)="enable()" class="btn btn-primary btn-block">
            <i-feather class="mr-4" name="power"></i-feather>
            Включить
          </button>
        </div>
      </ng-template>
      <hr/>
      <div class="row mx-0 align-items-center">
        <div class="col-auto pr-0">
          <app-avatar
            [id]="chat.id"
            [class.avatar-online]="chat?.online"
            [type]="chat.type"
            [avatar]="chat.avatar"
            [avatarFileId]="chat?.avatar_file_id"
            [avatarFileUniqueId]="chat?.avatar_file_unique_id"
            class="avatar mr-5"
          ></app-avatar>
        </div>
        <div class="col pl-0">
          <h6 class="text-truncate mb-0 font-weight-bold">
            <ng-template [ngIf]="chat.type === 'private' || chat.type === 'bot'" [ngIfElse]="chatTitle">
            <span
              *ngIf="chat?.name?.first; else userName"
              [innerHTML]="chat?.name?.first + ' ' + chat?.name?.last | replaceEmojis: 'facebook':20:64"
            ></span>
              <ng-template #userName
              ><span>{{ chat.username }}</span></ng-template
              >
            </ng-template>
            <ng-template #chatTitle>
              <span [innerHTML]="chat.title | replaceEmojis: 'facebook':20:64"></span>
            </ng-template>
          </h6>
        </div>
      </div>
    </ng-template>
  </div>
</div>
